const cards = [
  {
    id: 1,
    src: 'https://picsum.photos/200/300',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quaerat ducimus minus perspiciatis quas rem quod, maiores quos illo corporis recusandae.',
    alt: 'post-1',
  },
  {
    id: 2,
    src: 'https://picsum.photos/400/200',
    description:
      'Provident odio culpa amet repudiandae itaque iste ducimus dolorem, quod quisquam minus?',
    alt: 'post-2',
  },
  {
    id: 3,
    src: 'https://picsum.photos/300/500',
    description: 'Explicabo qui aliquam perspiciatis ea similique magnam?',
    alt: 'post-3',
  },
  {
    id: 4,
    src: 'https://picsum.photos/700/1000',
    description:
      'Quia optio id molestiae assumenda provident saepe architecto corrupti repudiandae inventore aliquid fuga, blanditiis dignissimos fugiat culpa ipsam harum aut. Architecto, accusantium?',
    alt: 'post-4',
  },
  {
    id: 5,
    src: 'https://picsum.photos/1000/800',
    description:
      'Voluptatum, quos ratione expedita tempore dolor magnam architecto culpa vitae. Tempore inventore totam voluptatibus asperiores, earum deserunt ullam ducimus! Labore molestias porro deleniti quas alias esse totam, voluptatem distinctio fugit cupiditate. Nesciunt!',
    alt: 'post-5',
  },
];

export default cards;
